;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('coreTableColumnRowLink', tableColumnRowLink)

  /* @ngInject */
  function tableColumnRowLink () {
    return {
      restrict: 'E',
      scope: {
        value: '<',
        redirect: '<'
      },
      templateUrl: '/core/directives/table-columns/table-column-row-link/table-column-row-link-directive.html?$$REVISION$$'
    }
  }
})()
